import { render, staticRenderFns } from "./SendViaPeppolModalBillit.vue?vue&type=template&id=47e78bda&scoped=true"
import script from "./SendViaPeppolModalBillit.vue?vue&type=script&lang=ts"
export * from "./SendViaPeppolModalBillit.vue?vue&type=script&lang=ts"
import style0 from "./SendViaPeppolModalBillit.vue?vue&type=style&index=0&id=47e78bda&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e78bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e78bda')) {
      api.createRecord('47e78bda', component.options)
    } else {
      api.reload('47e78bda', component.options)
    }
    module.hot.accept("./SendViaPeppolModalBillit.vue?vue&type=template&id=47e78bda&scoped=true", function () {
      api.rerender('47e78bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SendViaPeppolModalBillit.vue"
export default component.exports